<template>
  <GradientCard
    class="method-card"
    :class="{ 'method-card--inactive': nonActive }"
    inner-class="method-card__inner"
    @click="onClick"
  >
    <div class="method-card__image">
      <img :src="card.image" alt="banner" />
    </div>
    <div class="method-card__content">
      <div class="method-card__title" v-html="card.title" />
      <ul class="method-card__benefits">
        <li v-for="item in card.benefits" :key="item">
          {{ item }}
        </li>
      </ul>

      <div class="method-card__footer">
        <!-- У недоступного метода вместо курса стоит причина: показывать
             выгодный курс на том, что нельзя купить, значит вводить в
             заблуждение (RBXGD-1109). -->
        <div class="method-card__course">
          {{ nonActive ? $t('general.temporarilyUnavailable') : card.course }}
        </div>

        <img :src="card.icon" class="method-card__icon" alt="icon" />
      </div>
    </div>
  </GradientCard>
</template>

<script>
import GradientCard from '@/components/GradientCard/GradientCard.vue'

export default {
  name: 'MethodCard',
  components: { GradientCard },
  props: {
    card: {
      type: Object,
      required: true
    },
    // Метод выключен у поставщика. Карточка остаётся на месте, но гаснет и не
    // ведёт в покупку — по образцу неактивных методов Дерева (RBXGD-1109).
    nonActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // Клик гасит и pointer-events в стилях, но проверка нужна и здесь: она
    // защищает пути мимо мыши — клавиатуру и программный вызов.
    onClick() {
      if (this.nonActive) return
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
@import './method-card';
</style>
